import { render, staticRenderFns } from "./modaleClienti.vue?vue&type=template&id=3a83ca47"
import script from "./modaleClienti.vue?vue&type=script&lang=js"
export * from "./modaleClienti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports